import type { TOffer } from 'shared/types/TRankingService';

import type { TMplApplicationOrganization } from '../types';

export const getUniqueOnlineGroupOrganizations = (offers: TOffer[]): TMplApplicationOrganization[] => {
  const seenLogos = new Set<string>();
  const organizations: TMplApplicationOrganization[] = [];

  offers.forEach((offer) => {
    if (offer.group !== 'Online') {
      return;
    }

    const { organizationLogo } = offer;

    if (!organizationLogo || seenLogos.has(organizationLogo)) {
      return;
    }

    seenLogos.add(organizationLogo);
    organizations.push({
      id: offer.bankId,
      name: offer.bankName,
      logo: organizationLogo,
    });
  });

  return organizations;
};
